import { render, staticRenderFns } from "./PositionEmail.vue?vue&type=template&id=060a1571&scoped=true"
import script from "./PositionEmail.vue?vue&type=script&lang=js"
export * from "./PositionEmail.vue?vue&type=script&lang=js"
import style0 from "./PositionEmail.vue?vue&type=style&index=0&id=060a1571&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060a1571",
  null
  
)

export default component.exports